import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType, QueryConfig } from '../../../lib/react-query';
import { fetchApi } from '../../../lib/fetchApi';
import { AlertCard } from '../types';

export const getAlertsStates = async (): Promise<AlertCard[]> => {

    const response = await fetchApi.get('/alert/status') as AlertCard[];
  return response;
}

type QueryFnType = typeof getAlertsStates;

type UseAlertsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useAlertsStates = ({ config }: UseAlertsOptions = {}) => 
    useQuery <ExtractFnReturnType<QueryFnType>, Error>({
    ...config,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    queryKey: ["alertsStates"],
    queryFn: () => getAlertsStates(),
    });

